/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Event } from "./Event";
import { EventFromJSON, EventFromJSONTyped, EventToJSON, EventToJSONTyped } from "./Event";

/**
 *
 * @export
 * @interface ApiGmwEventsList200Response
 */
export interface ApiGmwEventsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmwEventsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwEventsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwEventsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Event>}
   * @memberof ApiGmwEventsList200Response
   */
  results: Array<Event>;
}

/**
 * Check if a given object implements the ApiGmwEventsList200Response interface.
 */
export function instanceOfApiGmwEventsList200Response(
  value: object
): value is ApiGmwEventsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmwEventsList200ResponseFromJSON(json: any): ApiGmwEventsList200Response {
  return ApiGmwEventsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwEventsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwEventsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(EventFromJSON),
  };
}

export function ApiGmwEventsList200ResponseToJSON(json: any): ApiGmwEventsList200Response {
  return ApiGmwEventsList200ResponseToJSONTyped(json, false);
}

export function ApiGmwEventsList200ResponseToJSONTyped(
  value?: ApiGmwEventsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(EventToJSON),
  };
}
